import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
const Gauge = require("svg-gauge");

const CircleBar = (props) => {
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  let cpuGauge;
  const [state, setState] = useStateIfMounted({
    value: 0, //0.75
    unit: props.unit, //"Temp(C)",
    minvalue: props.min, //"0"
    maxvalue: props.max, //"1"
    title: props.title, //"Circlebar",
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    mqtt_topics.Readings_topic +
    state.title;

  function listenforlivedata() {
    //console.log("target_live_reading_topic " + target_live_reading_topic);
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        //console.log(topic, "From Surf Mode: " + message.toString());
        message = JSON.parse(message.toString());
        //setState({ ...state, value: message.toString() });
        cpuGauge.setValue(
          message.value == undefined || isNaN(message.value)
            ? "0"
            : message.value.toString()
        );
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    // Create a new Gauge
    cpuGauge = Gauge(document.getElementById(state.title + "_container"), {
      max: state.maxvalue,
      // custom label renderer
      label: function (value) {
        return value;
        //return Math.round(value) + "/" + this.max;
      },
      value: state.value,
      // Custom dial colors (Optional)
      /* color: function (value) {
        return "#123456";
        if (value < 20) {
          return "#5ee432"; // green
        } else if (value < 40) {
          return "#fffa50"; // yellow
        } else if (value < 60) {
          return "#f7aa38"; // orange
        } else {
          return "#ef4655"; // red
        }
      },*/
    });

    // Set gauge value
    cpuGauge.setValue(state.value);
    // Set value and animate (value, animation duration in seconds)
    //cpuGauge.setValueAnimated(parseInt(state.value), 1);
  }, []);

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  return (
    <div className="col">
      <div className="card text-center bg-light circularcard">
        <div className="card-header">{state.title}</div>
        <div className="card-body">
          <center>
            <div>
              <div
                id={state.title + "_container"}
                className="gauge-container"
                width={10}
                height={10}
              />
            </div>
          </center>
        </div>
      </div>
    </div>
  );
};
export default CircleBar;
